import { useState, useEffect } from 'react';
import TopNavBar from '../components/TopNavBar';
import SideNavBar from '../components/SideNavBar';

// Components
import ChartLoyaltySignupsPerDay from '../components/ChartLoyaltySignupsPerDay';
import ChartCustomersByCountyMap from '../components/ChartCustomersByCountyMap';
import ChartRepeatPurchaseRate from '../components/ChartRepeatPurchaseRate';
import ChartRepeatPurchaseRatePerDay from '../components/ChartRepeatPurchaseRatePerDay';
import ChartUniqueTransactionsPerDay from '../components/ChartUniqueTransactionsPerDay';
import ChartTransactionValuePerDay from '../components/ChartTransactionValuePerDay';
import ChartAverageTransactionValuePerDay from '../components/ChartAverageTransactionValuePerDay';
import ChartTransactionsPerDayByBranch from '../components/ChartTransactionsPerDayByBranch';
import ChartTransactionValuePerDayByBranch from '../components/ChartTransactionValuePerDayByBranch';
import ChartCollectorCardStampsPerDay from '../components/ChartCollectorCardStampsPerDay';
import ChartCollectorCardCompletionRate from '../components/ChartCollectorCardCompletionRate';
import ChartCollectorCardsCompletedPerDay from '../components/ChartCollectorCardsCompletedPerDay';
import ChartCollectorCardsInProgressByStampNumber from '../components/ChartCollectorCardsInProgressByStampNumber';
import ChartAverageStampsPerActiveCollectorCard from '../components/ChartAverageStampsPerActiveCollectorCard';
import ChartTopBranchesByStampsIssued from '../components/ChartTopBranchesByStampsIssued';
import ChartTopBranchesByCollectorCardsEver from '../components/ChartTopBranchesByCollectorCardsEver';
import ChartCollectorCardCompletionFunnel from '../components/ChartCollectorCardCompletionFunnel';
import useIsMobile, { DESKTOP_CONTENT_MARGIN_LEFT, MOBILE_CONTENT_MARGIN_LEFT } from '../hooks/useIsMobile';

const HomePage = (props) => {

  const [showInfoBox, setShowInfoBox] = useState(true);
  const [ windowHeight, setWindowHeight ] = useState(100);
  const [timeRange, setTimeRange] = useState('3months');
  const isMobile = useIsMobile();
  
  
  useEffect(() => {
    setWindowHeight(window.innerHeight);
  }, []);

  return (
    <div style={{ height : windowHeight, backgroundColor : 'white' }}>
      <TopNavBar handleUpdate = { props.handleUpdate } activeRoute = { props.activeRoute } />
      <div style={{ display : 'flex', flexDirection : 'row' }}>
      <SideNavBar handleUpdate = { props.handleUpdate } activeRoute = { props.activeRoute } />
      <div style={{ marginLeft: isMobile ? MOBILE_CONTENT_MARGIN_LEFT : DESKTOP_CONTENT_MARGIN_LEFT, marginRight : 10, marginTop : 0, paddingTop : 45, flex : 1, minWidth : 0 }}>
        <div style={{ display : 'flex', flexDirection : 'row', width : '100%', alignItems : 'flex-start', justifyContent : 'space-between', gap : 12 }}>
          <h1 style = {{ fontSize: 26, fontWeight : 'bold', paddingTop : 10, paddingLeft: 10 }}>Home</h1>
          <div style={{ marginTop : 10, padding : 10, backgroundColor : 'white', borderStyle : 'solid', borderWidth : 2, borderColor : '#DEDEDE', borderRadius : 5 }}>
            <select id='timeSelector' value={ timeRange } onChange={ (e) => { setTimeRange(e.target.value); } } style={{ display : 'block', width : 120, padding : 10, borderWidth : 0, outline : 'none', boxShadow : 'none' }}>
              <option value="1week">1 Week</option>
              <option value="1month">1 Month</option>
              <option value="3months">3 Months</option>
              <option value="6months">6 Months</option>
              <option value="9months">9 Months</option>
              <option value="1year">1 Year</option>
              <option value="2years">2 Years</option>
              <option value="3years">3 Years</option>
              <option value="alltime">All time</option>
            </select>
          </div>
        </div>

        { showInfoBox ? (
          <div style={{ marginTop : 10 }} className="alert alert-primary lert-dismissible fade show" role="alert">
            <h4 className="alert-heading">Welcome back 👋</h4>
            <p>Welcome back to the Petstop Loyalty Dashboard.</p>
            <button style={{ position : 'absolute', top : 10, right : 10 }} type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={ () => { setShowInfoBox(false); }} onPress={ () => { setShowInfoBox(false); }}></button>
          </div>
        ) : null }


        <div className="container-fluid" style={{ paddingLeft : 0, paddingRight : 0, width : '100%' }}>
          <div style={{ display : 'flex', flexDirection : 'column', gap : 20, width : '100%', alignItems : 'stretch' }}>
            <div style={{ width : '100%' }}>
              <ChartLoyaltySignupsPerDay timeRange={ timeRange } />
            </div>
            <div style={{ width : '100%' }}>
              <ChartCustomersByCountyMap />
            </div>
            <div style={{ width : '100%' }}>
              <ChartCustomersByCountyMap metricType='spend' timeRange={ timeRange } />
            </div>
            <div style={{ width : '100%' }}>
              <ChartRepeatPurchaseRate timeRange={ timeRange } />
            </div>
            <div style={{ width : '100%' }}>
              <ChartRepeatPurchaseRatePerDay timeRange={ timeRange } />
            </div>
            {/*
            <div style={{ width : '100%' }}>
              <ChartUniqueUsersPerDay timeRange={ timeRange } />
            </div>
            */}
            <div style={{ width : '100%' }}>
              <ChartUniqueTransactionsPerDay timeRange={ timeRange } />
            </div>
            <div style={{ width : '100%' }}>
              <ChartTransactionsPerDayByBranch timeRange={ timeRange } />
            </div>
            <div style={{ width : '100%' }}>
              <ChartTransactionValuePerDay timeRange={ timeRange } />
            </div>
            <div style={{ width : '100%' }}>
              <ChartAverageTransactionValuePerDay timeRange={ timeRange } />
            </div>
            <div style={{ width : '100%' }}>
              <ChartTransactionValuePerDayByBranch timeRange={ timeRange } />
            </div>
            <div style={{ width : '100%' }}>
              <ChartCollectorCardStampsPerDay timeRange={ timeRange } />
            </div>
            <div style={{ width : '100%' }}>
              <ChartCollectorCardsCompletedPerDay timeRange={ timeRange } />
            </div>
            <div style={{ width : '100%' }}>
              <ChartCollectorCardCompletionRate timeRange={ timeRange } />
            </div>
            <div style={{ width : '100%' }}>
              <ChartCollectorCardsInProgressByStampNumber timeRange={ timeRange } />
            </div>
            <div style={{ width : '100%' }}>
              <ChartAverageStampsPerActiveCollectorCard timeRange={ timeRange } />
            </div>
            <div style={{ width : '100%' }}>
              <ChartTopBranchesByStampsIssued timeRange={ timeRange } />
            </div>
            <div style={{ width : '100%' }}>
              <ChartTopBranchesByCollectorCardsEver />
            </div>
            <div style={{ width : '100%' }}>
              <ChartCollectorCardCompletionFunnel timeRange={ timeRange } />
            </div>
          </div>
        </div>

      </div>
    </div>


    </div>
  );

};

export default HomePage;
